import { ModalProps, ModalSizes } from './Modal.types';
import { ReactComponent as CloseIcon } from '../../../assets/vectors/close.svg';
import '../../../styles/Modal.css';

export default ({
  isOpen,
  setOpen,
  onClose,
  closeOnClickOutside = false,
  hasCloseIcon,
  children,
  className,
  size = ModalSizes.Medium,
  ...props
}: ModalProps) => {
  const closeModal = () => {
    if (onClose) {
      onClose();
    }
    setOpen(false);
  };

  return (
    <div
      data-testid="dark-screen"
      className={`dark-screen ${isOpen ? 'dark-screen--opened' : 'dark-screen--closed'}`}
      {...(closeOnClickOutside && {
        onClick: closeModal,
      })}>
      <div
        data-testid="modal"
        className={`modal ${className ? className : ''} modal--${size}`}
        {...(closeOnClickOutside && {
          onClick: (e) => e.stopPropagation(),
        })}
        {...props}>
        {hasCloseIcon && (
          <div className="modal__close" data-testid="close-icon" onClick={closeModal}>
            <CloseIcon />
          </div>
        )}
        {children}
      </div>
    </div>
  );
};
